/**
 * Constant array reference to all serializer registrations in the app. The actual registrations are separated out into
 * its own file to work around cyclic dependency issues.
 *
 * @see registerSerializers.ts
 */
export const serializerRegistrations = [];
